module.exports = __webpack_public_path__ + "media/images/emblems/Biezwil-blason-63fad0d15bb298b23cf3466fdeaef7ef.png";